/**
 * List Schema of ResponsavelGrupoEconomico
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ResponsavelGrupoEconomico} from '@/model/resource/ResponsavelGrupoEconomico'

export class ListResponsavelGrupoEconomicoSchema extends Schema {
  readonly name = 'ListResponsavelGrupoEconomico'

  readonly fieldSet: FieldSet<ResponsavelGrupoEconomico> = {
    responsavelMaster: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavelMaster?.$id,
      },
    }),
    responsavelPermitido: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavelPermitido?.$id,
      },
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
  }
}
